import { createSelector } from 'reselect';
import chargelab from '../../assets/images/chargelab-logo.svg';
import { envApi } from '../../services/env.api';
import { Theme } from '../types/theme.interface';

const initStore = {
  networkLogo: chargelab,
  chartColor: '',
  navigationSelectedColor: '',
  btnHoverColor: '',
  secondaryBtnBgColor: '',
} as Theme;

export const getCurrentTheme = createSelector(
  [envApi.endpoints.fetchThemeSettings.select(undefined)],
  (endpoint) => endpoint.data || initStore,
);
